// Навигация стрелками внутри группы одноимённых кнопок (сегмент-контрол,
// пилюли пресетов). Выносится отдельно, потому что нужна как минимум двоим —
// ui/Segmented и ui/DatePresetTabs, — а расходиться этим двум нельзя: обе
// группы стоят на одном экране (Funnels), и разная раскладка клавиш в соседних
// контролах читается как поломка.
//
// Почему не хук: состояния здесь нет вовсе. Текущий элемент — это
// document.activeElement, а порядок обхода — порядок узлов в DOM; и то и другое
// читается в момент нажатия. Хук добавил бы реф и синхронизацию индекса с
// перерисовками списка опций, не дав ничего взамен.

// Помечает кнопку как участника обхода. Селектор по data-атрибуту, а не по
// тегу: внутри группы могут появиться и другие фокусируемые узлы (счётчик со
// ссылкой), и обходить нужно именно сегменты.
export const ROVING_ITEM_ATTR = 'data-roving-item';

const KEYS = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];

// Вешается на КОНТЕЙНЕР группы (событие всплывает с кнопки), поэтому
// обработчик один на группу, а не по одному на кнопку.
//
// ⚠️ Стрелки двигают ТОЛЬКО фокус, выбор не меняют. Каноничный паттерн
// radiogroup требует выбирать сразу при переходе, но здесь каждый выбор —
// это перезапрос аналитики (смена пресета на Funnels перегружает воронку).
// Проход стрелками от «Today» до «Last 90 days» отправил бы шесть запросов
// подряд, из которых пять никому не нужны. Поэтому выбор — на Enter/Space,
// то есть штатным поведением <button>, и дописывать его не требуется.
export const onRovingKeyDown = (event) => {
  if (!KEYS.includes(event.key)) return;

  const items = Array.from(
    event.currentTarget.querySelectorAll(`[${ROVING_ITEM_ATTR}]:not([disabled])`),
  );
  if (items.length < 2) return;

  const current = items.indexOf(document.activeElement);
  // Фокус не на сегменте (например, на счётчике внутри) — не наше событие.
  if (current === -1) return;

  event.preventDefault();

  let next;
  if (event.key === 'Home') next = 0;
  else if (event.key === 'End') next = items.length - 1;
  else {
    // Вертикальные стрелки работают наравне с горизонтальными: группа
    // переносится по строкам (`flex-wrap` в DatePresetTabs), и «вниз» там
    // означает ровно «дальше по списку».
    const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
    // По кругу: дойдя до края, обход продолжается с другого конца.
    next = (current + step + items.length) % items.length;
  }

  items[next].focus();
};

// Roving tabindex: из всей группы в таб-порядке стоит один элемент — выбранный.
// Иначе Tab обходил бы каждую пилюлю по отдельности, и на семи пресетах путь
// до следующего контрола растягивался бы на семь нажатий.
//
// Когда выбранного нет (период задан руками и ни одному пресету не равен),
// точкой входа становится первый: без этого в группу нельзя было бы попасть
// с клавиатуры вообще.
export const rovingTabIndex = (isActive, index, activeIndex) =>
  (activeIndex === -1 ? index === 0 : isActive) ? 0 : -1;
